/**
 * iurop-tabs.js — pestañas subrayadas genéricas (Glucody).
 * Delegación sobre [data-tabs]: clic en [data-tab="i"] activa esa pestaña
 * y muestra solo [data-panel="i"] dentro del mismo contenedor.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-tab]');
    if (!tab) return;
    var wrap = tab.closest('[data-tabs]');
    if (!wrap) return;
    var index = tab.getAttribute('data-tab');

    wrap.querySelectorAll('[data-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
    });
    wrap.querySelectorAll('[data-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== index;
    });
  });
})();
